// Angular
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IBookingSearchParameters } from 'libraries/interfaces/IBookingSearchParameters';
import { BookingResourceService } from 'libraries/service/resources/booking/bookingResource.service';
import { Yii } from "libraries/interfaces/Yii";
import { IApiBookingSearchResponse } from "libraries/service/resources/booking/IApiBookingSearchResponse";
import { faTimes, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'booking-summary-badge',
    template: `
        <div class="round-badge sep-right" [title]="htmlTitle">
            <ng-container *ngIf="error; else noError;"><fa-icon [icon]="iconTimes"></fa-icon></ng-container>
            <ng-template #noError>
                <span class="result" *ngIf="total !== null; else loading;">{{ total | shortNumberSuffix}}</span>
                <ng-template #loading>
                    <loader type="small"></loader>
                </ng-template>
            </ng-template>
        </div>
    `,
    styleUrls: ['../../../../shared/styles/round-badge.scss']
})
export class BookingSummaryBadgeComponent implements OnInit {
    @Input()
    public query: IBookingSearchParameters;

    @Input()
    public title: string;

    @Output()
    public readonly onTotalOfBookings: EventEmitter<{
        title: string;
        total: number;
    }> = new EventEmitter();

    public total?: number = null;
    public htmlTitle: string = Yii.t('wui-sasha-js', 'Chargement en cours...');

    public error: object = null;

    public iconTimes: IconDefinition = faTimes;

    constructor (
        private bookingResourceService: BookingResourceService,
    ) {}

    public ngOnInit (): void {
        this.bookingResourceService.search(this.query).subscribe((data: IApiBookingSearchResponse) => {
            this.onTotalOfBookings.emit({ title: this.title, total: data.recordset.total});
            this.total = data.recordset.total;
            this.htmlTitle = String(this.total);
        }, (error: object) => {
            this.error = error;
            this.htmlTitle = Yii.t('wui-sasha-js', 'Erreur de chargement.');
        });
    }
}
